var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader"},[_c('div',{staticClass:"balls-loader",style:({
        '--length': _vm.$options.balls.length
      })},_vm._l((_vm.$options.balls),function(ball,index){return _c('div',{key:ball.id,staticClass:"item",style:({
             '--index': index,
           }),domProps:{"innerHTML":_vm._s(ball.svg)}})}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }